var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87AACA",
    fillRule: "evenodd",
    d: "M32.079 48.871a8 8 0 1 0 15.842 0h19.412v17.796a2 2 0 0 1-2 2H14.667a2 2 0 0 1-2-2V48.87h19.412Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#87AACA",
    fillRule: "evenodd",
    d: "M48.666 49.333a8.667 8.667 0 1 1-17.32-.462h-18.68l6.374-18.845a2 2 0 0 1 1.895-1.36h38.13a2 2 0 0 1 1.895 1.36l6.373 18.845H48.654c.008.153.012.307.012.462Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FBFD",
    fillRule: "evenodd",
    d: "M47.398 50.636C47.398 54.335 44.086 58 40 58s-7.667-3.635-7.667-7.333c0-.12-.174-.936-.167-1.055h-13.5l5.441-13.228c.235-.628.886-1.05 1.618-1.05h28.55c.732 0 1.383.422 1.617 1.05l5.441 13.228H47.388c.007.119.01.904.01 1.024Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#87AACA",
    strokeWidth: 2.5,
    d: "M13.5 49.008v17.659c0 .644.522 1.166 1.167 1.166h50.666c.645 0 1.167-.522 1.167-1.166V49.008l-6.33-18.715a1.167 1.167 0 0 0-1.105-.793h-38.13c-.5 0-.945.319-1.105.793L13.5 49.008Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#87AACA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M13.666 49.333h8.667m-.333 0h8.497c1.25 0 1.25.88 1.25 1.334 0 4.418 3.665 8 8.185 8 4.52 0 8.184-3.582 8.184-8 0-.455 0-1.334 1.25-1.334H66M56.733 13.535l-7.4 8.302M39.4 10.667v11.17-11.17ZM22 13.535l7.4 8.302-7.4-8.302Z"
  })));
};
export default SvgEmpty;